<script setup lang="ts">
useSeoMeta({
  title: 'Blog — Shakir Abdulrahim',
  ogTitle: 'Blog — Shakir Abdulrahim',
  description: 'Technical articles on web development, hardware engineering, IoT, and AI.',
})

const { data: posts } = await useFetch('/api/blog', {
  default: () => [],
})

function formatDate(date: string) {
  return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}
</script>

<template>
  <div class="py-24">
    <div class="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <p class="mb-4 text-sm font-medium tracking-widest text-[var(--color-amber)] uppercase">
        Blog
      </p>
      <h1 class="mb-6 text-4xl font-bold text-[var(--color-text)] sm:text-5xl">
        Thoughts & Learnings
      </h1>
      <p class="mb-12 text-lg text-[var(--color-text-muted)]">
        Technical articles on web development, hardware engineering, and AI.
      </p>

      <div class="space-y-8">
        <NuxtLink
          v-for="post in posts"
          :key="(post as any).id"
          :to="`/blog/${(post as any).slug}`"
          class="group block rounded-xl border border-[var(--color-card-border)] bg-[var(--color-card-bg)] p-6 transition-all duration-300 hover:border-[var(--color-amber)]/20 hover:shadow-[0_0_40px_rgba(250,185,91,0.05)]"
        >
          <div class="flex items-center gap-3 text-sm text-[var(--color-text-muted)]">
            <time v-if="(post as any).date_published">{{ formatDate((post as any).date_published) }}</time>
            <span v-if="(post as any).read_time" class="flex items-center gap-1">
              <UIcon name="i-lucide-clock" class="size-3.5" />
              {{ (post as any).read_time }} min read
            </span>
          </div>
          <h2 class="mt-2 text-xl font-semibold text-[var(--color-text)] transition-colors group-hover:text-[var(--color-amber)]">
            {{ (post as any).title }}
          </h2>
          <p class="mt-2 text-[var(--color-text-muted)]">
            {{ (post as any).excerpt }}
          </p>
          <div v-if="(post as any).tags" class="mt-4 flex flex-wrap gap-1.5">
            <span
              v-for="tag in (post as any).tags"
              :key="tag"
              class="rounded-md border border-[var(--color-card-border)] bg-[var(--color-surface-hover)] px-2 py-0.5 text-xs text-[var(--color-text-muted)]"
            >
              {{ tag }}
            </span>
          </div>
        </NuxtLink>
      </div>

      <p v-if="!posts?.length" class="mt-10 text-center text-[var(--color-text-muted)]">
        No posts yet. Check back soon!
      </p>
    </div>
  </div>
</template>
